import React from 'react'

export default function WisFilterIcon() {
  return (
	 <div className="agenda-filter-bar__wis-filter__icon">
		<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="6.5" cy="6.5" r="6.5" fill="white"/>
			<path d="M8.8954 4.60968C9.03487 4.47021 9.03487 4.24408 8.8954 4.1046C8.75592 3.96513 8.52979 3.96513 8.39032 4.1046L6.5 5.99492L4.60968 4.1046C4.47021 3.96513 4.24408 3.96513 4.1046 4.1046C3.96513 4.24408 3.96513 4.47021 4.1046 4.60968L5.99492 6.5L4.1046 8.39032C3.96513 8.52979 3.96513 8.75592 4.1046 8.8954C4.24408 9.03487 4.47021 9.03487 4.60968 8.8954L6.5 7.00508L8.39032 8.8954C8.52979 9.03487 8.75592 9.03487 8.8954 8.8954C9.03487 8.75592 9.03487 8.52979 8.8954 8.39032L7.00508 6.5L8.8954 4.60968Z" fill="#326C90" stroke="#326C90" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/>
		</svg>
	 </div>
  )
}
